import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelSelect as _vModelSelect, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-99a2450a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "form_top"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  class: "list"
};
const _hoisted_4 = {
  key: 0,
  class: "list_li"
};
const _hoisted_5 = {
  class: "li_title"
};
const _hoisted_6 = {
  class: "feld"
};
const _hoisted_7 = {
  key: 1,
  class: "list_li"
};
const _hoisted_8 = {
  class: "li_title"
};
const _hoisted_9 = {
  key: 2,
  class: "list_li"
};
const _hoisted_10 = {
  class: "li_title"
};
const _hoisted_11 = {
  key: 3,
  class: "list_li"
};
const _hoisted_12 = {
  class: "li_title"
};
const _hoisted_13 = {
  class: "select"
};
const _hoisted_14 = ["value"];
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "butflex"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "buttom"
}, "提交")], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_divider = _resolveComponent("van-divider");
  const _component_van_field = _resolveComponent("van-field");
  const _component_van_radio = _resolveComponent("van-radio");
  const _component_van_radio_group = _resolveComponent("van-radio-group");
  const _component_van_checkbox = _resolveComponent("van-checkbox");
  const _component_van_checkbox_group = _resolveComponent("van-checkbox-group");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString($props.content.title), 1), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.content.jsonData, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: 'form' + index
    }, [item.type == '0' ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(item.name), 1), _createVNode(_component_van_divider), _createElementVNode("div", _hoisted_6, [_createVNode(_component_van_field, {
      onInput: $options.changeFile,
      modelValue: $data.fileValue,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.fileValue = $event),
      placeholder: item.value
    }, null, 8, ["onInput", "modelValue", "placeholder"])])])) : _createCommentVNode("", true), item.type == '2' ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, _toDisplayString(item.name), 1), _createVNode(_component_van_divider), _createVNode(_component_van_radio_group, {
      onChange: $options.change,
      direction: "horizontal",
      class: "radio_flex",
      modelValue: $data.radio,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.radio = $event)
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.value1, (radioval, radioIndex) => {
        return _openBlock(), _createElementBlock("div", {
          key: 'radio' + radioIndex
        }, [_createVNode(_component_van_radio, {
          name: radioIndex
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(radioval), 1)]),
          _: 2
        }, 1032, ["name"])]);
      }), 128))]),
      _: 2
    }, 1032, ["onChange", "modelValue"])])) : _createCommentVNode("", true), item.type == '3' ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(item.name), 1), _createVNode(_component_van_divider), _createVNode(_component_van_checkbox_group, {
      modelValue: $data.checkout,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.checkout = $event),
      onChange: $options.checkchange,
      direction: "horizontal",
      class: "radio_flex"
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.value1, (check, checkIndex) => {
        return _openBlock(), _createElementBlock("div", {
          key: 'check' + checkIndex
        }, [_createVNode(_component_van_checkbox, {
          shape: "square",
          name: checkIndex
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(check), 1)]),
          _: 2
        }, 1032, ["name"])]);
      }), 128))]),
      _: 2
    }, 1032, ["modelValue", "onChange"])])) : _createCommentVNode("", true), item.type == '1' ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString(item.name), 1), _createVNode(_component_van_divider), _createElementVNode("div", _hoisted_13, [_withDirectives(_createElementVNode("select", {
      class: "selectStyle",
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.select = $event),
      name: "fruit"
    }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.value1, (sele, selekIndex) => {
      return _openBlock(), _createElementBlock("option", {
        key: 'sele' + selekIndex,
        value: sele
      }, _toDisplayString(sele), 9, _hoisted_14);
    }), 128))], 512), [[_vModelSelect, $data.select]])])])) : _createCommentVNode("", true)]);
  }), 128)), _hoisted_15])]);
}